var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgMicrosoft = function SvgMicrosoft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 36 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.246 7.461H0v11.247h11.246V7.46Z",
    fill: "#F35325"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.703 7.461H12.457v11.247h11.246V7.46Z",
    fill: "#81BC06"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.246 19.919H0v11.246h11.246V19.92Z",
    fill: "#05A6F0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.703 19.919H12.457v11.246h11.246V19.92Z",
    fill: "#FFBA08"
  })));
};

export default SvgMicrosoft;